import { VALID_2D_FILES_EXTENSIONS } from "../helpers/is2DFile";
import { VALID_3D_FILES_EXTENSIONS } from "../helpers/is3DFile";
import { VALID_SPREADSHEET_FILES_EXTENSIONS } from "../helpers/isSpreadsheetFile";
import { FileTypeType } from "../types";

const ONE_KB = 1024;
const ONE_MB = 1024 * ONE_KB;
const ONE_GB = 1024 * ONE_MB;

export const UPLOAD_CONFIG: Record<
  FileTypeType,
  { mimeType: "all" | string[]; extensions: "all" | string[]; maxFileSize: number }
> = {
  PART: {
    mimeType: "all", // We keep all here because some files are not using mimeTypes
    extensions: [...VALID_3D_FILES_EXTENSIONS, ...VALID_2D_FILES_EXTENSIONS],
    maxFileSize: 500 * ONE_MB,
  },
  COMPANY_LOGO: {
    mimeType: ["image/png", "image/jpeg", "image/jpg", "image/gif", "image/webp", "image/svg+xml"],
    extensions: ["png", "jpg", "jpeg", "gif", "webp", "svg"],
    maxFileSize: 10 * ONE_MB,
  },
  COMPANY_CGV: {
    mimeType: ["application/pdf"],
    extensions: ["pdf"],
    maxFileSize: 20 * ONE_MB,
  },
  MATERIALS_PRICING: {
    mimeType: [
      "text/csv",
      "application/csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
    extensions: ["csv", "xls", "xlsx"],
    maxFileSize: 200 * ONE_MB,
  },
  MATERIALS: {
    mimeType: [
      "text/csv",
      "application/csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
    extensions: ["csv", "xls", "xlsx"],
    maxFileSize: 200 * ONE_MB,
  },
  ONBOARDING: {
    mimeType: "all",
    extensions: "all",
    maxFileSize: 20 * ONE_GB,
  },
  QUOTE_PDF: {
    mimeType: ["application/pdf"],
    extensions: ["pdf"],
    maxFileSize: 20 * ONE_MB,
  },
  EMAIL_REQUEST_SPREADSHEET: {
    mimeType: [
      "text/csv",
      "application/csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
    extensions: VALID_SPREADSHEET_FILES_EXTENSIONS,
    maxFileSize: 20 * ONE_MB,
  },
  EMAIL_REQUEST_CONTENT: {
    mimeType: ["text/plain"],
    extensions: ["txt"],
    maxFileSize: 5 * ONE_MB,
  },
};

export const getAccept = (extensions: "all" | string[]): string[] | undefined => {
  return extensions === "all" ? undefined : extensions;
};
